import { Analytics, getAnalytics, logEvent } from 'firebase/analytics';
import { FirebaseApp, initializeApp } from 'firebase/app';
import {
  Auth,
  connectAuthEmulator,
  createUserWithEmailAndPassword,
  getAuth,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInAnonymously,
  signInWithEmailAndPassword,
  signOut,
  User,
  UserCredential,
} from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectFirestoreEmulator, Firestore, getFirestore } from 'firebase/firestore';
import { connectStorageEmulator, FirebaseStorage, getDownloadURL, getStorage } from 'firebase/storage';

import FirebaseConfig from 'app/config/FirebaseConfig';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
const app: FirebaseApp = initializeApp(FirebaseConfig);
const db: Firestore = getFirestore(app);
export const functions = getFunctions(app);
let analytics: Analytics;

// Connect to emulators in local development
const isEmulator = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true';

if (isEmulator) {
  console.log('🔧 Connecting to Firebase Emulators...');

  // Keep admin completion calls on the same backend as their Firestore writes.
  connectFunctionsEmulator(functions, 'localhost', 5001);

  // Connect Firestore emulator
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('✅ Connected to Firestore emulator');
  } catch (error) {
    console.log(`Firestore emulator already connected ${error}`);
  }

  // Connect Storage emulator
  const storage: FirebaseStorage = getStorage(app);
  try {
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('✅ Connected to Storage emulator');
  } catch (error) {
    console.log(`Storage emulator already connected ${error}`);
  }

  // Connect Auth emulator
  const auth: Auth = getAuth(app);
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    console.log('✅ Connected to Auth emulator');
  } catch (error) {
    console.log(`Auth emulator already connected ${error}`);
  }
} else {
  console.log('🌐 Using production Firebase services');
}

if (typeof window !== 'undefined' && !isEmulator) {
  analytics = getAnalytics(app);
}

const storage: FirebaseStorage = getStorage(app);
const auth: Auth = getAuth(app);

export {
  analytics,
  auth,
  createUserWithEmailAndPassword,
  db,
  app as default,
  getDownloadURL,
  logEvent,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInAnonymously,
  signInWithEmailAndPassword,
  signOut,
  storage,
};
export type { User, UserCredential };
